import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const transferCheck = async (data: object) => {
  return await POST({ url: Api.transferCheck, data, showError: false })
}

export const transferSubmit = async (data: object) => {
  return await POST({ url: Api.transferSubmit, data, showError: false })
}
